import { SafeBaseObject } from "@app/core/models/base-object.models";

export interface IGeoTreeDestination {
  GeoTreeID: number;
  GeoTreeName: string;
  GeoTreeTypeID: number;
  DestinationTypeID: number;
  LEVEL_1_ID: number;
  LEVEL_2_ID: number;
  LEVEL_3_ID: number;
  LEVEL_4_ID: number;
  LEVEL_5_ID: number;
  ExternalCityID: number;
  Search?: number;
  IsVisible: boolean;
}


export class GeoTreeSearch extends SafeBaseObject {
  description: string = '';
  details: GeoTreeSearchDetails[] = [];
  destinationType: string = '';
  level1ID: number = 0;
  level2ID?: number = 0;
  masterImages: any[] = [];
  name: string = '';
  order: number = 0;
  isExpanded?: boolean = false;
  parentID?: number = 0;


  constructor(data?: any) {
    super();
    if (data) {
      super.updateData(data);
      this.updateData(data);
    }
  }
  updateData(data?: any) {
    if (!data) return;
    if (data.Details) this.details = data.Details.map((d: any) => new GeoTreeSearch(d));

  }
}

export class GeoTreeSearchDetails extends SafeBaseObject {
  level1ID: number = 0;
  level2ID: number = 0;
  name: string = '';
  order: number = 0;
  isChecked: boolean = false;

  constructor(data?: any) {
    super();
    if (data) {
      super.updateData(data);
      this.updateData(data);
    }
  }
}

export interface IDynamicMapApiParams {
  bkgID?: number
  PackageID?: number
}

export class ResDynamicMapResponse extends SafeBaseObject {

  statusCode = 0
  error = false
  response: any = {}
  location = ''

  constructor(data?: any) {
    super()
    if (data) {
      super.updateData(data)
      this.updateData(data)
    }
  }
  updateData(data?: any) {
    if (!data) return
  }
}

export interface IResGeoTreeCountryAndContinent {
  GeoTreeID?: number;
  GeoTreeName?: string;
  DestinationTypeID?: number;
  DestinationTypeName?: string;
  ExternalCityID?: number;
  ExternalCity?: string;
}

export interface IResAPIGetGeoTreeCountryAndContinent {
  GeoTreeID?: number;
  GeoTreeName?: string;
}

export class ResTopicItinerary extends SafeBaseObject {
  destinationID: number = 0;
  destinationName: string = '';
  topic: string = '';
  subject: string = '';
  notes: string = '';

  constructor(data?: any) {
    super();
    if (data) {
      super.updateData(data);
      this.updateData(data);
    }
  }

  updateData(data?: any) {
    if (!data) return;
  }
}

export interface IResApiGetGeoTreeTopicItinerary {
  BkgID?: number;
  VoyageID?: number;
  PackageID?: number;
}

export class ResBkgVisaHealth extends SafeBaseObject {
  destinationID = 0
  destinationName = ''
  topic = ''
  subject = ''
  notes = ''

  constructor(data?: any) {
    super();
    if (data) {
      super.updateData(data);
      this.updateData(data);
    }
  }

  updateData(data?: any) {
    if (!data) return;
  }
}

export class ResVoyageDescription extends SafeBaseObject {
  entIns = ''
  voyageNumber = ''
  voyageName = ''
  voyageDescription = ''
  voyageIncluded = ''
  portAgentEmbark = ''
  portAgentDebark = ''
  pierEmbark = ''
  pierDebark = ''
  groundOpEmbark = ''
  groundOpDebark = ''
  formalNights = ''

  constructor(data?: any) {
    super();
    if (!data) return

    super.updateData(data);
    this.updateData(data);

  }
}
